<template>
  <b-row v-if="showButtonNext">
    <b-col cols="10" class="mb-5 mx-auto button-next">
      <b-button block variant="primary" :disabled="isDisabled"
        :aria-label="$t('button_next')" @click="onNextClick" @keyup.enter.space="onNextClick">
        {{ $t("button_next") }}
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
  import {AnswerService} from "../Services"
  import {Storage} from '../../../core/Utils'

  export default {
    name: "QuestionNext",
    data() {
      return {
        isDisabled: false
      }
    },
    props: {
      questionNumber: {
        type: Number,
        required: true
      },
      showButtonNext: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      getTimeDurationQuestion(){
        const initialTimestamp = Storage.getInitialTimestamp()
        const elapsedTimeInMs = Date.now() - initialTimestamp
        return Math.round(elapsedTimeInMs / 1000)
      },
      onNextClick() {
        if (this.questionNumber === 10) {
          if (!this.isDisabled) {
            this.isDisabled = true

            const elapsedSeconds = this.getTimeDurationQuestion()
            Storage.setElapsedSeconds(elapsedSeconds)

            this.$router.push({name: 'QuizResults'})

            if (this.isValidAuthenticate()) {
              AnswerService.saveQuiz(Storage.getUser().id, Storage.getAnswers(), elapsedSeconds)
                .then(() => {})
            }
          }
        }
        if (this.questionNumber < 10) {
          this.$router.push({ name: "Quiz", params: {questionNumber: (this.questionNumber + 1).toString()}})
        }
      },
      isValidAuthenticate() {
        let user = Storage.getUser();
        return Object.keys(user).length !== 0;
      }
    },
    watch: {
    '$route.params.questionNumber': {
      handler: function() {
        this.isDisabled = false
      }
    },
  }
  }
</script>

<style lang="stylus" scoped>

</style>
